import { getSimpleDataSelector } from '@cp-shared-9/frontend-integration';
import { RootState } from '../../../../store/rootReducer';

export const StateContentSelector = getSimpleDataSelector((state: RootState) => state.content.stateCatalog);
